module.exports = __webpack_public_path__ + "img/UnionPay.c6f2a235.png";